<template>
  <div class="ems-page">
    <NavBar class="mb-4">
      <template #left>
        <BackLink />
      </template>
      <template #center>
        <span>
          <b>Choose your truck</b>
        </span>
      </template>
      <template #right>
        <b-nav-item :disabled="!selectedTruck" data-testid="button-next" @click="onNextClick">
          <span
            :class="{
              'next-enabled': selectedTruck,
              'next-disabled': !selectedTruck,
            }"
          >
            Next
          </span>
        </b-nav-item>
      </template>
    </NavBar>
    <b-container class="h-100">
      <b-row align-h="center" class="pt-2 pb-4">
        <b-col>
          <b-form-group>
            <b-list-group>
              <b-list-group-item v-for="truck in trucks" :key="truck.id" @click="onTruckClick(truck, $event)">
                <b-form-radio
                  v-model="selectedTruck"
                  :value="truck.id"
                  name="trucks"
                  data-testid="radio-button-trucks"
                  >{{ truck.name }}</b-form-radio
                >
              </b-list-group-item>
            </b-list-group>
          </b-form-group>
          <b-spinner v-if="requestState === RequestState.Loading"></b-spinner>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import NavBar from "@/App/components/NavBar.vue";
import BackLink from "@/App/components/BackLink.vue";
import { RequestState } from "@/Utils/vuex/RequestState";

export default {
  name: "TruckSelection",
  components: { NavBar, BackLink },
  data() {
    return {
      selectedTruck: undefined,
    };
  },
  computed: {
    RequestState() {
      return RequestState;
    },
    ...mapGetters("TeamSelection", ["selectedTeam"]),
    ...mapGetters("TruckSelection", ["trucks", "requestState"]),
  },
  mounted() {
    this.loadTrucks(this.selectedTeam.id);
  },
  methods: {
    ...mapActions("TruckSelection", ["loadTrucks", "selectTruck"]),
    onTruckClick(truck, evt) {
      if (evt.target.nodeName === "LABEL") {
        return;
      }
      this.selectedTruck = truck.id;
      this.selectTruck(truck);
    },
    onNextClick() {
      this.$router.push({ name: "start" }).catch((error) => console.log(error));
    },
  },
};
</script>

<style scoped>
.list-group .list-group-item {
  color: #000;
  text-align: left;
}

.list-group .list-group-item .custom-control-label {
  cursor: pointer;
}

.next-disabled {
  cursor: not-allowed;
}

.next-enabled {
  color: red;
  cursor: pointer;
}
</style>
